export enum APPOINTMENT_STATES_ENUM {
  WAITING_ATTENDANCE = 'AGUARDANDO_ATENDIMENTO',
  ATTENDANCE_STARTED = 'ATENDIMENTO_INICIADO',
  ATTENDANCE_STARTING = 'INICIANDO_CONSULTA',
  CALL_STARTED = 'CHAMADA_INICIADA',
  CALL_RESTARTED = 'CHAMADA_REINICIADA',
  CALL_ENDED = 'CHAMADA_ENCERRADA',
  ATTENDANCE_CANCELLED_MEDIC = 'ATENDIMENTO_CANCELADO_PELO_MEDICO',
  ATTENDANCE_CANCELLED_TIME = 'ATENDIMENTO_CANCELADO_POR_ATRASO',
  ATTENDANCE_END = 'ATENDIMENTO_CONCLUIDO',
  ATTENDANCE_CANCELLED_PATIENT_BLOCKED = 'ATENDIMENTO_CANCELADO_PACIENTE_BLOQUEADO',
}

export interface RealtimeAppointmentStatus {
  encaixe: boolean
  idFila: number | string
  idAtendimento: number
  modoAtendimento: 'AGENDADO' | 'IMEDIATO'
  status: APPOINTMENT_STATES_ENUM
  roomId?: string
}

export type AppointmentRoutineProps = {
  appointmentId?: number
  isMostRecent?: boolean
  fitInAttendance?: boolean
  roomId?: string
}

export type AppointmentRoutine = {
  [key in APPOINTMENT_STATES_ENUM]?: (props?: AppointmentRoutineProps) => void
}

export type UseMonitoringProps = {
  realtimeAppointments: RealtimeAppointmentStatus[]
}
